import { Button, FormItem } from '@heathmont/moon-components';
import Translate from '~/client/shared/i18n/Translate';

type Props = {
  loading: boolean;
  isSubmitDisabled: boolean;
  translateId: string;
  handleSubmit?: () => void;
  dataTestId?: string;
};

const SubmitButtonFormItem: FC<Props> = ({
  loading,
  translateId,
  isSubmitDisabled,
  dataTestId,
  handleSubmit,
}) => (
  <FormItem>
    <Button
      variant="primary"
      fullWidth
      progress={loading}
      disabled={isSubmitDisabled}
      onClick={handleSubmit}
      type="submit"
      data-testid={dataTestId}
      className="min-h-[48px] px-4 py-3"
    >
      <Translate id={translateId} />
    </Button>
  </FormItem>
);

export default SubmitButtonFormItem;
